import type { TooltipRenderProps } from 'react-joyride';
import * as styles from './pattern.css';

import { useI18n } from '@affine/i18n';

const welImgSrc =
  'https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/intro_welcome_x3.png';
const lightImgSrc =
  'https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/intro_light_x3.png';
const quoteImgSrc =
  'https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/intro_quote_x3.png';

export const WelcomeTooltip = (props: TooltipRenderProps) => {
  const { closeProps, tooltipProps, step } = props;

  const t = useI18n();

  return (
    <div className={styles.welcomeIntro} {...tooltipProps}>
      <img className={styles.welcomeIcon} src={welImgSrc} alt="AI" />
      <p className={styles.welcomeWrapper}>{step.content}</p>
      <button className={styles.welcomeButton} {...closeProps}>
        {t['com.affine.user-guide.close-title']()}
      </button>
    </div>
  );
};

export const ApplyTooltip = (props: TooltipRenderProps) => {
  const { closeProps, tooltipProps, step } = props;
  return (
    <div className={styles.useTooltip} {...tooltipProps}>
      <img className={styles.lightIcon} src={lightImgSrc} alt="AI" />

      <p className={styles.useWrapper}>{step.content}</p>

      <button className={styles.useButton} {...closeProps}>
        Get
      </button>
    </div>
  );
};

export const QuoteTooltip = (props: TooltipRenderProps) => {
  const { closeProps, tooltipProps, step } = props;
  return (
    <div className={styles.useTooltip} {...tooltipProps}>
      <img className={styles.quoteIcon} src={quoteImgSrc} alt="AI" />
      <p className={styles.useWrapper}>{step.content}</p>
      <button className={styles.useButton} {...closeProps}>
        Get
      </button>
    </div>
  );
};
